<template>
  <b-card :class="['kpi-card', 'border-0', 'shadow-sm', cardBgClass]" no-body>
    <b-card-body>
      <h6 class="card-title text-white mb-2">{{ title }}</h6>
      <div class="d-flex justify-content-between align-items-center">
        <span class="display-6 text-white">{{ value }}</span>
        <i v-if="trend !== null" :class="trendIconClass" class="bi text-white"></i>
      </div>
      <div class="small mt-1">
        <span v-if="trend !== null" :class="trendTextClass">{{ formattedTrend }}%</span>
        <span v-if="trend !== null" class="text-white-50"> vs Yesterday</span>
        <span v-else class="text-white-50">No previous data</span>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'KpiCard',
  components: {
    BCard,
    BCardBody,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    trend: {
      type: [Number, null],
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    cardBgClass() {
      const map = {
        'blue darken-1': 'bg-primary',
        'green darken-1': 'bg-success',
        'orange darken-1': 'bg-warning',
        'purple darken-1': 'bg-info',
        primary: 'bg-primary',
        success: 'bg-success',
        warning: 'bg-warning',
        info: 'bg-info',
      };
      return map[this.color] || 'bg-primary';
    },
    trendIconClass() {
      if (this.trend === null) return '';
      return this.trend >= 0 ? 'bi-arrow-up-right' : 'bi-arrow-bottom-left';
    },
    trendTextClass() {
      if (this.trend === null) return '';
      return this.trend >= 0 ? 'text-success' : 'text-danger';
    },
    formattedTrend() {
      if (this.trend === null) return 'N/A';
      return Math.abs(this.trend).toFixed(2);
    },
  },
};
</script>

<style scoped>
.kpi-card {
  margin: 10px;
}
</style>
